import { fetchPath } from '../../utils/api'
import state from './state'
import mutations from './mutations'
import actionsFactory from './actions'
import getters from './getters'
import flash from './flash'

export default {
  namespaced: true,
  state,
  mutations,
  actions: actionsFactory({ fetchPath }),
  getters,
  modules: { flash },
}
